<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="info-wrapper mb-3">
            <img id="photo" src="../assets/mmp.jpg" width="400" height="400" :alt="data.name" class="rounded-circle img-fluid w-15 mb-3">
            <h1 id="name">{{ data.name }}</h1>
            <p id="description" v-html="data.description"></p>
            <p id="coupons" v-html="data.coupons"></p>
            <p id="combo" v-html="data.combo"></p>
          </div>
          <nav id="social" class="social-wrapper mb-4" aria-label="Redes sociais">
            <a :href="social.url" target="_blank" class="mx-2" rel="noopener noreferrer" :aria-label="social.title" v-for="(social, index) in data.socials" v-bind:key="index" @click="trackSocialClick(social)">
              <font-awesome-icon :icon="parseIcon(social.image)" aria-hidden="true" />
            </a>
          </nav>
          <ul class="links-wrapper col-12 col-md-6 offset-md-3 list-unstyled">
            <li class="item" v-for="(link, index) in data.links" v-bind:key="index">
              <a :href="link.url" target="_blank" rel="noopener noreferrer" class="d-flex justify-content-center btn btn-white d-block mb-3 links" @click="trackLinkClick(link, index)">
                <div class="margin-right"><font-awesome-icon :icon="parseIcon(link.image)" aria-hidden="true" /></div>
                <div v-html="link.title"></div>
              </a>
            </li>
            <li>
              <p class="footer" v-html="data.footer"></p>
            </li>
          </ul>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
const axios = require("axios");
export default {
  name: 'Home',
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    axios.get("/data.json").then((res) => {
      this.data = res.data;
      
      setTimeout(function(){
        gsap.from("#photo", {duration: 1, y: 100, opacity: 0, ease: "power3.out"});
        gsap.from("#name", {duration: 1, opacity: 0, ease: "power3.out", delay: .2});
        gsap.from("#description", {duration: 1, opacity: 0, ease: "power3.out", delay: .2});
        gsap.from("#social", {duration: 1, opacity: 0, ease: "power3.out", delay: .2});
        gsap.from(".links, .footer", {duration: 1, y: -20, opacity: 0, ease: "power3.out", delay: .2, stagger: 0.1});
      }, 1);
    });
  },
  methods: {
    // Fire-and-forget wrapper around gtag so a missing/blocked GA script never breaks a click.
    trackEvent(eventName, params) {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    },
    stripHtml(html) {
      return (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    },
    // data.json historically stores icons as raw FontAwesome CSS classes
    // (e.g. "fa-twitter" or "fas fa-envelope"). This parses that string into
    // the [prefix, name] pair the FontAwesomeIcon component expects, keeping
    // the same "defaults to brand style unless a style class is given"
    // behavior the old template had (it always prepended "fab ").
    // NOTE: only icons registered in src/main.js will render — adding a new
    // brand/icon to data.json for a future campaign requires importing it
    // there too, since we no longer bundle the full icon set.
    parseIcon(classString) {
      const parts = (classString || '').trim().split(/\s+/);
      const stylePrefixes = ['fas', 'far', 'fab'];
      let prefix = 'fab';
      let name = '';
      parts.forEach((part) => {
        if (stylePrefixes.includes(part)) {
          prefix = part;
        } else if (part.indexOf('fa-') === 0) {
          name = part.slice(3);
        }
      });
      return name ? [prefix, name] : ['fas', 'circle'];
    },
    trackLinkClick(link, index) {
      this.trackEvent('select_content', {
        content_type: 'affiliate_link',
        item_id: 'link_' + index,
        link_title: this.stripHtml(link.title).slice(0, 100),
        link_url: link.url
      });
    },
    trackSocialClick(social) {
      this.trackEvent('social_click', {
        content_type: 'social_link',
        social_platform: social.title,
        link_url: social.url
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-right {
  margin-right: 10px;
}
.w-15 {
  max-width: 15%;
}
.social-wrapper a {
  font-size: 28px;
  color: rgb(230, 230, 230) !important;
}
.social-wrapper a:hover {
  color: #f9f9f9 !important;
}
#photo {
  border: 5px solid rgb(99, 99, 99);
}
.footer {
  text-align: center;
  background-color: #000;
  margin-top: 15px;
  margin-bottom: 10px!important;
  border-radius: 10px;
  padding: 7px;
}
</style>
